import { useGetOne } from 'react-admin';
import { Gateway } from 'types/embedded/gateway';
import { getGatewayCurrencyIds } from 'utils/getGatewayCurrencyIds';

export const useGatewayCurrencies = (gatewayId?: string | null) => {
  const { data: gateway, isLoading } = useGetOne<Gateway>(
    'gateways',
    { id: gatewayId ?? '' },
    { enabled: !!gatewayId },
  );

  return { gateway, currencyIds: getGatewayCurrencyIds(gateway), isLoading };
};
